import type { QuoteRateAccessorial } from '@/views/screens/Quote';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { FC } from 'react';

const accessorialColumns: ColumnsType<QuoteRateAccessorial> = [
  {
    title: 'Cost Type',
    dataIndex: 'costType',
    key: 'costType',
  },
  {
    title: 'Cost Name',
    dataIndex: 'costName',
    key: 'costName',
  },
  {
    title: 'Cost',
    dataIndex: 'cost',
    key: 'cost',
  },
  {
    title: 'Currency Code',
    dataIndex: 'currency',
    key: 'currency',
  },
];

interface QuoteRatePanelContentProps {
  accessorials: QuoteRateAccessorial[];
}

export const QuoteRatePanelContent: FC<QuoteRatePanelContentProps> = ({
  accessorials,
}: { accessorials: QuoteRateAccessorial[] }) => {
  return (
    <div className="mt-2">
      {accessorials?.length > 0 && (
        <Table<QuoteRateAccessorial>
          dataSource={accessorials.map((item, index) => ({ ...item, key: index }))}
          columns={accessorialColumns}
          pagination={false}
          size="small"
        />
      )}
    </div>
  );
};
